import { render, staticRenderFns } from "./ShippinFeeList.vue?vue&type=template&id=ef5a0b40"
import script from "./policyShippinFeeList?vue&type=script&lang=js&external"
export * from "./policyShippinFeeList?vue&type=script&lang=js&external"
import style0 from "./ShippinFeeList.vue?vue&type=style&index=0&id=ef5a0b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports